import { Grid, TextField } from '@mui/material';
import { useState } from 'react';
import {
  useCreateOperatingSystemMutation,
  useFindOneOperatingSystemQuery,
  useRemoveOperatingSystemMutation,
  useUpdateOperatingSystemMutation,
} from '../../api/api-hooks';
import ItemOptionsBar from '../../components/ItemOptionsBar';
import { Item } from '../../utils/sharedTypes';
import { nullStringCheck } from '../../utils/stringManipulation';

interface Props {
  selectedOS: Item[];
  setSelectedOS: React.Dispatch<React.SetStateAction<Item[]>>;
}

interface TypeForm {
  osName: string;
}

const addFormInitialState: TypeForm = {
  osName: '',
};

const OperatingSystemsOptionsBar = ({ selectedOS, setSelectedOS }: Props) => {
  const [deleteOS] = useRemoveOperatingSystemMutation();
  const [createOS] = useCreateOperatingSystemMutation();
  const [editOS] = useUpdateOperatingSystemMutation();
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  return (
    <>
      <ItemOptionsBar
        selectedItems={selectedOS}
        setSelectedItems={setSelectedOS}
        handlerMiddleware={(name, value, state) => ({})}
        itemValidator={(item: any) => {
          if (!item.osName) return false;
          return true;
        }}
        formInstructions='OS name is required.'
        addFormInitialState={addFormInitialState}
        itemName='Operating System'
        dialogSize='sm'
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
        childrenCreator={(addFormState: TypeForm, handler: any) => (
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <TextField
                margin='dense'
                name='osName'
                label='Operating System Name'
                fullWidth
                value={nullStringCheck(addFormState.osName)}
                onChange={handler}
              />
            </Grid>
          </Grid>
        )}
        itemCreator={(item: TypeForm) => {
          if (!item.osName) return;
          return createOS({
            createOperatingSystemDto: {
              osName: item.osName,
            },
          });
        }}
        itemGetter={useFindOneOperatingSystemQuery}
        itemUpdater={(item: TypeForm) => {
          if (!item.osName) return;
          return editOS({
            id: Number(selectedOS[0].id),
            updateOperatingSystemDto: {
              id: Number(selectedOS[0].id),
              osName: item.osName,
            },
          });
        }}
        itemDeleter={deleteOS}
        deleteNotes='Deleting a type will delete associated software versions. Please use caution.'
      />
    </>
  );
};

export default OperatingSystemsOptionsBar;
